import React, { useEffect, useMemo, useState } from "react";
import {
  Box,
  Button,
  Card,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  MenuItem,
  Tabs,
  Tab,
  Select,
  FormControl,
  InputLabel,
  TextField,
  DialogContentText,
  Collapse,
  Snackbar,
  Alert,
  ToggleButtonGroup,
  ToggleButton,
  Avatar,
  CircularProgress
} from "@mui/material";
import {
  Add as AddIcon,
  Edit as EditIcon,
  Delete as DeleteIcon,
  EmojiEvents as TrophyIcon,
  KeyboardArrowDown as ExpandMoreIcon,
  KeyboardArrowUp as ExpandLessIcon
} from "@mui/icons-material";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";

import DateRangePicker from "./SimpleDateRangePicker";
import { useDispatch, useSelector } from "react-redux";
import { fetchAllChallenges } from "../../features/users/userSlice";
import {
  selectUsersChallenges,
  selectUsersChallengesLoading
} from "../../features/users/userSelectors";
import {
  addnewChallenge,
  deleteChallengeHandler,
  editChallengeHandler
} from "../../api/userApi";
import LeaderboardModal from "../Modals/Leaderboard";
import {
  selectAvailableCoaches,
  selectLevelDetails
} from "../../features/training/trainingSelectors";
import {
  getAllCoaches,
  getAllLevelDetails
} from "../../features/training/trainingSlice";
import useThemeColor from "../../utils/useTheme";
import useSignedUrl from "../../utils/useSignedUrl";
import getInitials from "../../utils/getInitials";
// import DateRangePicker from "./DateRangePicker";
dayjs.extend(utc);

const ChallengeTable = ({
  challenges,
  setSelectedChallenge,
  handleEdit,
  handleDeleteClick,
  setOpenLeaderboardModal,
  level,
  isFromSubAdmin
}) => {
  const [expanded, setExpanded] = useState(true);

  const filteredChallenges = challenges
    .filter((challenge) => challenge.levelName === level.name)
    ?.map((item) => {
      let data = 0;
      item?.userPoints?.forEach((user) => {
        if (
          ![
            ...new Set([
              ...item?.excluded_users_by_admin,
              ...item?.excluded_users
            ])
          ]?.includes(user?.userId?.toString())
        ) {
          data++; // Increment count if userId is not found in idsToCheck
        }
      });
      return {
        ...item,
        totalUsers: data
      };
    });

  //   const getInitials = (name) => {
  //     return name
  //       .split(" ")
  //       .map((n) => n[0])
  //       .join("")
  //       .toUpperCase();
  //   };

  if (filteredChallenges.length === 0) return null;

  return (
    <Card sx={{ mb: 3, borderRadius: 2, overflow: "hidden" }}>
      <Box
        sx={{
          p: 2,
          bgcolor: "primary.main",
          color: "white",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between"
        }}
      >
        <Typography
          textTransform={"capitalize"}
          variant="h6"
          sx={{ display: "flex", alignItems: "center" }}
        >
          <TrophyIcon sx={{ mr: 1 }} /> {level.title}
        </Typography>
        <IconButton
          onClick={() => setExpanded(!expanded)}
          sx={{ color: "white" }}
        >
          {expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
        </IconButton>
      </Box>
      <Collapse in={expanded}>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow
                sx={{
                  bgcolor: "primary.light"
                }}
              >
                <TableCell
                  align="center"
                  sx={{ color: "white", fontWeight: "bold" }}
                >
                  Challenge Name
                </TableCell>
                <TableCell
                  align="center"
                  sx={{ color: "white", fontWeight: "bold" }}
                >
                  Dates
                </TableCell>
                <TableCell
                  align="center"
                  sx={{ color: "white", fontWeight: "bold" }}
                >
                  Length
                </TableCell>
                <TableCell
                  align="center"
                  sx={{ color: "white", fontWeight: "bold" }}
                >
                  Paid Participants
                </TableCell>
                {/* <TableCell
                  align="center"
                  sx={{ color: "white", fontWeight: "bold" }}
                >
                  Participants
                </TableCell> */}
                <TableCell
                  align="center"
                  sx={{
                    color: "white",
                    fontWeight: "bold"
                  }}
                >
                  View Leaderboard
                </TableCell>
                <TableCell
                  align="center"
                  sx={{ color: "white", fontWeight: "bold" }}
                >
                  Actions
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {filteredChallenges.map((challenge) => (
                <TableRow
                  key={challenge._id}
                  sx={{ "&:hover": { backgroundColor: "#f5f5f5" } }}
                >
                  <TableCell align="center">
                    <Typography
                      variant="subtitle1"
                      sx={{ fontWeight: "medium" }}
                    >
                      {challenge.title}
                    </Typography>
                  </TableCell>
                  <TableCell align="center">
                    <Typography variant="body2">
                      {dayjs.utc(challenge.start_date).format("D MMM, YYYY")} -{" "}
                      {dayjs.utc(challenge.end_date).format("D MMM, YYYY")}
                    </Typography>
                  </TableCell>
                  <TableCell align="center">
                    <Typography variant="body2">
                      {dayjs
                        .utc(challenge.end_date)
                        .diff(dayjs.utc(challenge.start_date), "days") + 1}{" "}
                      Days
                    </Typography>
                  </TableCell>
                  <TableCell align="center">
                    <Typography variant="body2">
                      {challenge?.eligibleUsersCount || 0}
                    </Typography>
                  </TableCell>
                  {/* <TableCell align="center">
                    <Typography variant="body2">
                      {challenge?.totalUsers || 0}
                    </Typography>
                  </TableCell> */}
                  <TableCell
                    align="center"
                    // sx={{ display: "flex", justifyContent: "center" }}
                  >
                    {/* <AvatarGroup max={4} sx={{ justifyContent: "flex-start" }}>
                      {challenge.allowedUsers.map((user) => (
                        <Avatar
                          key={user.id}
                          src={user.avatar}
                          alt={user.name}
                          sx={{ bgcolor: "secondary.main" }}
                        >
                          {!user.avatar && getInitials(user.name)}
                        </Avatar>
                      ))}
                    </AvatarGroup> */}
                    <Button
                      sx={{
                        border: "none"
                      }}
                      onClick={() => {
                        setSelectedChallenge(challenge);
                        setOpenLeaderboardModal(true);
                      }}
                    >
                      View
                    </Button>
                  </TableCell>
                  <TableCell align="center">
                    <IconButton
                      color="primary"
                      onClick={() => handleEdit(challenge)}
                      sx={{ "&:hover": { backgroundColor: "primary.light" } }}
                    >
                      <EditIcon />
                    </IconButton>
                    <IconButton
                      color="error"
                      onClick={() => handleDeleteClick(challenge)}
                      sx={{ "&:hover": { backgroundColor: "error.light" } }}
                    >
                      <DeleteIcon />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Collapse>
    </Card>
  );
};
const ImageItem = ({ img }) => {
  const imgSrc = useSignedUrl(
    img,
    process.env.REACT_APP_BACKEND_PROFILE_IMAGE_LOCATION
  );

  return (
    <Box
      component="img"
      height={40}
      borderRadius="50%"
      width={40}
      src={imgSrc}
      alt="avatar"
    />
  );
};
const ChallengeManagement = ({ isFromSubAdmin = false }) => {
  const [open, setOpen] = useState(false);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [openLeaderboardModal, setOpenLeaderboardModal] = useState(false);
  const [selectedChallenge, setSelectedChallenge] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const dispatch = useDispatch();
  const challengeData = useSelector(selectUsersChallenges);
  const challengesLoading = useSelector(selectUsersChallengesLoading);
  const availableLevels = useSelector(selectLevelDetails) || [];
  const [currentCoach, setCurrentCoach] = useState(null);
  const currentAdmin = useSelector((state) => state.adminauth.admin);

  useEffect(() => {
    dispatch(
      fetchAllChallenges(
        isFromSubAdmin
          ? currentAdmin?.referenceId
          : currentCoach
            ? currentCoach
            : ""
      )
    );
  }, [dispatch, currentCoach]);

  const [formData, setFormData] = useState({
    name: "",
    level: "level1",
    dateRange: [null, null],
    allowedUsers: []
  });
  const [editMode, setEditMode] = useState(false);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [hasErrors, setHasErrors] = useState(false);
  useEffect(() => {
    dispatch(getAllLevelDetails());
  }, [dispatch]);

  const handleOpen = () => {
    setOpen(true);
    setEditMode(false);
    resetForm();
  };

  const handleClose = () => {
    setOpen(false);
    resetForm();
  };

  const resetForm = () => {
    setFormData({
      name: "",
      level: "level1",
      dateRange: [null, null],
      allowedUsers: []
    });
    setSelectedChallenge(null);
    setEditMode(false);
    setStartDate(null);
    setEndDate(null);
  };
  const [isSubmitting, setIsSubmitting] = useState(false);
  const availableCoaches = useSelector(selectAvailableCoaches) || [];
  useEffect(() => {
    dispatch(getAllCoaches());
  }, [dispatch]);
  const handleSubmit = async () => {
    try {
      if (isSubmitting) return;
      setIsSubmitting(true);
      if (hasErrors) return;
      if (!formData.name || !formData.level) return;
      if (editMode && selectedChallenge) {
        await editChallengeHandler({
          levelName: formData?.level,
          title: formData?.name,
          start_date: dayjs(startDate).format("YYYY-MM-DD"),
          end_date: dayjs(endDate).format("YYYY-MM-DD"),
          type: alignment,
          referenceId: currentAdmin?.referenceId || null,
          userType: currentAdmin?.userType || "Individual",

          id: selectedChallenge?._id
        });
        setSnackbarMessage("Challenge edited successfully");
      } else {
        await addnewChallenge({
          levelName: formData?.level,
          title: formData?.name,
          type: alignment,
          referenceId: currentAdmin?.referenceId || null,
          userType: currentAdmin?.userType || "Individual",
          start_date: dayjs(startDate).format("YYYY-MM-DD"),
          end_date: dayjs(endDate).format("YYYY-MM-DD")
        });
        setSnackbarMessage("Challenge created successfully");
      }
      setOpenSnackbar(true);

      dispatch(
        fetchAllChallenges(isFromSubAdmin ? currentAdmin?.referenceId : "")
      );
      setHasErrors(false);
      handleClose();
    } catch (err) {
      setSnackbarMessage(err?.message || "Create/Edit challenge failed.");
      setOpenSnackbar(true);
    } finally {
      setIsSubmitting(false);
    }
  };
  const handleEdit = (challenge) => {
    setSelectedChallenge(challenge);
    setAlignment(challenge.type || "BOTH");
    setFormData({
      name: challenge.title,
      level: challenge.levelName,
      // "Level " + challenge.levelName.slice(-1),
      dateRange: challenge.dateRange,
      allowedUsers: challenge.allowedUsers
    });
    setStartDate(dayjs.utc(challenge.start_date));
    setEndDate(dayjs.utc(challenge.end_date));
    setEditMode(true);
    setOpen(true);
  };

  const handleDeleteClick = (challenge) => {
    setSelectedChallenge(challenge);
    setDeleteDialogOpen(true);
  };

  const handleDeleteConfirm = async () => {
    await deleteChallengeHandler({ id: selectedChallenge._id });
    setDeleteDialogOpen(false);
    setSelectedChallenge(null);
    dispatch(
      fetchAllChallenges(isFromSubAdmin ? currentAdmin?.referenceId : "")
    );
  };
  const styles = useThemeColor();
  const [alignment, setAlignment] = useState("BOTH");

  const handleAlignment = (event, newAlignment) => {
    if (newAlignment === "BOTH") {
      setStartDate(null);
      setEndDate(null);
    }
    console.log(newAlignment);
    if (newAlignment !== null) {
      setAlignment(newAlignment);
    }
  };
  const [tabValue, setTabValue] = useState(0);

  // 3. Add tab change handler (add this with your other handlers)
  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  // 4. Filter challenges based on selected tab (add this before your return statement)
  const filteredChallengesByTab = useMemo(() => {
    const now = dayjs.utc();
    return challengeData.filter((challenge) => {
      const endDate = dayjs.utc(challenge.end_date);
      if (tabValue === 0) {
        // Current & Upcoming - end date is today or in the future
        return endDate.isSame(now, "day") || endDate.isAfter(now, "day");
      } else {
        // Past - end date is before today
        return endDate.isBefore(now, "day");
      }
    });
  }, [challengeData, tabValue]);

  return (
    <Box>
      <Card sx={{ mb: 3, p: 3, borderRadius: 2, bgcolor: "#f8f9fa" }}>
        <Typography
          variant="h6"
          sx={{
            mb: 2,
            fontWeight: 600,
            color: "primary.main",
            display: "flex",
            alignItems: "center",
            gap: 1
          }}
        >
          <TrophyIcon /> Leaderboard Display Rules
        </Typography>
        <Box component="ol" sx={{ pl: 2, m: 0 }}>
          <Typography
            component="li"
            variant="body2"
            sx={{ mb: 1.5, lineHeight: 1.6 }}
          >
            Leaderboards on the{" "}
            <Box
              component="a"
              href={process.env.REACT_APP_USER_APP_URL || "#"}
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                color: "primary.main",
                textDecoration: "none",
                fontWeight: 600,
                "&:hover": {
                  textDecoration: "underline"
                }
              }}
            >
              user side
            </Box>{" "}
            appear in the participants profile{" "}
            <strong>7 days out from the challenge start date</strong>.
          </Typography>
          <Typography
            component="li"
            variant="body2"
            sx={{ mb: 1.5, lineHeight: 1.6 }}
          >
            The leaderboard is populated with scores <strong>a)</strong> the day
            after the start date (since "today's" points display "tomorrow"),
            and <strong>b)</strong> with any paid participant that has logged
            food in the challenge dates.
          </Typography>
          <Typography
            component="li"
            variant="body2"
            sx={{ mb: 1.5, lineHeight: 1.6 }}
          >
            The last day to add a participant to a challenge with a leaderboard
            is <strong>7 days from the start date</strong>.
          </Typography>
          <Typography
            component="li"
            variant="body2"
            sx={{ mb: 1.5, lineHeight: 1.6 }}
          >
            For <strong>#800gChallenge</strong> challenges, unpaid (free trial)
            participants are removed from the leaderboard as of Day 8.
          </Typography>
          <Typography component="li" variant="body2" sx={{ lineHeight: 1.6 }}>
            Participants must have <strong>completed prior levels</strong> to be
            eligible for Lazy Macros and Three Pillars Method challenges.
          </Typography>
        </Box>
      </Card>

      <Box
        display="flex"
        justifyContent="end"
        alignItems="center"
        mb={3}
        gap={3}
      >
        {currentAdmin?.adminUserId && (
          <FormControl sx={{ minWidth: 200 }}>
            <InputLabel id="demo-simple-select-label">Select coach</InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={currentCoach || ""}
              label="Select coach"
              onChange={(e) => {
                setCurrentCoach(e.target.value);
              }}
            >
              <MenuItem value={""}>
                <Box
                  display="flex"
                  justifyContent="center"
                  gap="10px"
                  sx={{ justifyContent: "center !important", width: "100%" }}
                  alignItems="center"
                >
                  All
                </Box>
              </MenuItem>
              {availableCoaches?.map((item) => (
                <MenuItem key={item._id} value={item._id}>
                  <Box display="flex" gap="10px" alignItems="center">
                    {item.profilePic ? (
                      <ImageItem img={item.profilePic} />
                    ) : (
                      <Avatar sx={{ width: 40, height: 40 }}>
                        {getInitials(item.name)}
                      </Avatar>
                    )}
                    <Typography fontSize="14px" fontWeight={400}>
                      {item.name}
                    </Typography>
                  </Box>
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )}
        <Button
          variant="contained"
          startIcon={<AddIcon />}
          onClick={handleOpen}
          sx={{
            borderRadius: 2,
            textTransform: "none",
            px: 3,
            py: 1,
            boxShadow: 3
          }}
        >
          Create Challenge
        </Button>
      </Box>
      <Box sx={{ borderBottom: 1, borderColor: "divider", mb: 3 }}>
        <Tabs
          value={tabValue}
          onChange={handleTabChange}
          aria-label="challenge tabs"
          sx={{
            "& .MuiTabs-indicator": {
              backgroundColor: "primary.main"
            }
          }}
        >
          <Tab
            label="Current & Upcoming"
            sx={{
              textTransform: "none",
              fontWeight: tabValue === 0 ? "bold" : "normal"
            }}
          />
          <Tab
            label="Past"
            sx={{
              textTransform: "none",
              fontWeight: tabValue === 1 ? "bold" : "normal"
            }}
          />
        </Tabs>
      </Box>

      {/* Update the mapping to use filtered challenges */}
      {challengesLoading ? (
        <Box
          sx={{
            display: "flex",
            height: "200px",
            justifyContent: "center",
            alignItems: "center"
          }}
        >
          <CircularProgress />
        </Box>
      ) : filteredChallengesByTab?.length > 0 ? (
        availableLevels?.map(({ levelName, title }) => (
          <ChallengeTable
            key={levelName}
            setSelectedChallenge={setSelectedChallenge}
            setOpenLeaderboardModal={setOpenLeaderboardModal}
            challenges={filteredChallengesByTab} // Changed from challengeData to filteredChallengesByTab
            handleEdit={handleEdit}
            handleDeleteClick={handleDeleteClick}
            level={{ name: levelName, title }}
            isFromSubAdmin={isFromSubAdmin}
          />
        ))
      ) : (
        <Box
          sx={{
            display: "flex",
            height: "200px",
            justifyContent: "center",
            alignItems: "center",
            color: "grey"
          }}
        >
          No challenges found
        </Box>
      )}

      {/* Create/Edit Challenge Dialog */}
      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth="md"
        fullWidth
        PaperProps={{
          elevation: 24,
          sx: { borderRadius: 3 }
        }}
      >
        <DialogTitle
          sx={{
            bgcolor: "primary.main",
            color: "white",
            display: "flex",
            alignItems: "center",
            gap: 2
          }}
        >
          <TrophyIcon />
          {editMode ? "Edit Challenge" : "Create New Challenge"}
        </DialogTitle>
        <DialogContent sx={{ pt: 3 }}>
          <Box sx={{ display: "flex", flexDirection: "column", gap: 3, p: 2 }}>
            <TextField
              fullWidth
              label="Challenge Name"
              value={formData.name}
              onChange={(e) =>
                setFormData({ ...formData, name: e.target.value })
              }
              required
            />

            <FormControl fullWidth>
              <InputLabel>Pillar</InputLabel>
              <Select
                value={formData.level}
                label="Pillar"
                onChange={(e) => {
                  setFormData({ ...formData, level: e.target.value });
                  setStartDate(null);
                  setEndDate(null);
                }}
              >
                {availableLevels?.map((item) => (
                  <MenuItem value={item.levelName}>{item.title}</MenuItem>
                ))}
              </Select>
            </FormControl>
            {currentAdmin?.userType === "Coach" || !isFromSubAdmin ? (
              <ToggleButtonGroup
                value={alignment}
                exclusive
                onChange={handleAlignment}
                aria-label="text alignment"
                sx={{
                  backgroundColor: styles.lightGreyColor, // Black background
                  overflow: "hidden",
                  width: "100%",
                  margin: "0 0 16px 0"
                }}
              >
                <ToggleButton
                  value="BOTH"
                  aria-label="both"
                  sx={{
                    textTransform: "none",
                    fontWeight: 600,
                    // color: "#FCFCFC !important",
                    flex: 1,
                    "&.Mui-selected": {
                      color: "#FCFCFC !important",
                      backgroundColor: "#368AD0",
                      ":hover": {
                        backgroundColor: "#368AD0"
                      }
                    }
                  }}
                >
                  Diary Logging & Program Points
                </ToggleButton>
                <ToggleButton
                  value="DIARY"
                  aria-label="diary"
                  sx={{
                    fontWeight: 600,
                    flex: 1,
                    textTransform: "none",
                    // color: "#FCFCFC !important",
                    "&.Mui-selected": {
                      color: "#FCFCFC !important",
                      backgroundColor: "#368AD0",
                      ":hover": {
                        backgroundColor: "#368AD0"
                      }
                    }
                  }}
                >
                  Diary Logging Points Only
                </ToggleButton>
              </ToggleButtonGroup>
            ) : (
              <></>
            )}
            <DateRangePicker
              optionValue={alignment}
              setHasErrors={setHasErrors}
              existingRanges={challengeData?.map((item) => ({
                startDate: item.start_date,
                endDate: item.end_date,
                level: item.levelName,
                id: item._id
              }))}
              startDate={startDate}
              currentLevel={formData.level}
              setStartDate={setStartDate}
              endDate={endDate}
              currentRecordId={selectedChallenge?._id}
              setEndDate={setEndDate}
            />
          </Box>
        </DialogContent>
        <DialogActions sx={{ p: 3 }}>
          <Button
            onClick={handleClose}
            variant="outlined"
            sx={{ borderRadius: 2 }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleSubmit}
            variant="contained"
            sx={{ borderRadius: 2 }}
            disabled={
              isFromSubAdmin ? !formData?.name : hasErrors || !formData?.name
            }
          >
            {editMode ? "Update Challenge" : "Create Challenge"}
          </Button>
        </DialogActions>
      </Dialog>
      <Snackbar
        open={openSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        autoHideDuration={1000}
        onClose={() => setOpenSnackbar(false)}
      >
        <Alert
          onClose={() => setOpenSnackbar(false)}
          severity={snackbarMessage?.includes("success") ? "success" : "error"}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
      <LeaderboardModal
        open={openLeaderboardModal}
        leaderboardData={challengeData}
        setOpen={setOpenLeaderboardModal}
        selectedChallenge={selectedChallenge}
        referenceId={currentAdmin?.referenceId}
        isFromSubAdmin={isFromSubAdmin}
        currentCoach={currentCoach}
      />
      {/* Delete Confirmation Dialog */}
      <Dialog
        open={deleteDialogOpen}
        onClose={() => setDeleteDialogOpen(false)}
        PaperProps={{
          elevation: 24,
          sx: { borderRadius: 3 }
        }}
      >
        <DialogTitle sx={{ color: "error.main" }}>Delete Challenge</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to delete the challenge "
            {selectedChallenge?.title}"? This action cannot be undone.
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ p: 2 }}>
          <Button onClick={() => setDeleteDialogOpen(false)} variant="outlined">
            Cancel
          </Button>
          <Button
            onClick={handleDeleteConfirm}
            variant="contained"
            color="error"
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default ChallengeManagement;
